import { connect } from "react-redux";

import {
    importXmlsAction,
    uploadFileAction,
    uploadFufByFilePropertiesAction,
} from "../../../../ActionCreators/FufUploadActionCreator";
import {
    CombinatorType,
    CombineFufResult,
    FufCombineMethod,
} from "../../../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";
import { CandyDispatch } from "../../../Store/CandyReduxTypes";
import { CustomFile } from "../../../../../Helpers/file";
import { FullFormState } from "../../../Store/FullFormState";
import { ParsedUploadFileProperties } from "../../../../../../../Common/CandyApiClient/Types/DraftActions/FileProperties";

import { PatchFufByAttachmentModal } from "./PatchFufByAttachment";

const mapStateToProps = (state: FullFormState) => ({
    currentGfv: state.settings.gfv,
    modalSettings: state.modalState,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    importXmls: (
        driveUris: string[],
        combineMethod: FufCombineMethod,
        combinatorType: CombinatorType,
        isImportByFuf: boolean,
        args?: string[]
    ): Promise<CombineFufResult | undefined> =>
        dispatch(importXmlsAction(driveUris, combineMethod, combinatorType, isImportByFuf, args)),
    updateFuf: (driveURLs: string[], abortSignal: AbortSignal): Promise<ParsedUploadFileProperties> =>
        dispatch(uploadFufByFilePropertiesAction(driveURLs, abortSignal)),
    uploadFile: (): Promise<CustomFile | undefined> => dispatch(uploadFileAction),
});

export const PatchFufByAttachmentModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PatchFufByAttachmentModal);
